import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
export const vatLevelSchema = baseObjectSchema.extend({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
});

export const getVatLevelsSchema = z.array(vatLevelSchema);

export type GetVatLevelsResponse = z.infer<typeof getVatLevelsSchema>;
